

const expenses = [
    {
        id: 1, type: 'expense',
        name: "Taxi to work",
        category: "Transport",
        created: "2022-06-16",
        amount: (5).toFixed(2),
        currency: "$",
        note: '',
        bankAccount: "Card"
    },
]


export default expenses;